import { StyleProps, Text } from '@chakra-ui/react'
import { ContentNode, ContentNodeUtils } from '@helo/cms'
import { If, pipe } from '@helo/utils'

import { Pill } from '../../components/Pill/Pill'
import { Skeleton } from '../../components/SkeletonLoader'
import { TypeRenderer } from '../../datatypes/TypeRenderer'
import { createWidget } from '../widget-utils'

export interface PillWidgetProps extends StyleProps {
  contentNode: ContentNode
  isLoading: boolean
}

export const PillWidget = ({
  contentNode,
  isLoading,
  ...props
}: PillWidgetProps) => {
  if (isLoading) {
    return <Skeleton w="100px" h="20px" />
  }

  if (!contentNode) return null
  if (Array.isArray(contentNode) && contentNode.length === 0) return null

  const contentNodeWithStyles =
    contentNode &&
    pipe(
      contentNode,
      If.then(
        (node: ContentNode) => ContentNodeUtils.isKind('FIELD')(node),
        (node: ContentNode) =>
          ContentNodeUtils.getOfType()(node as never) as ContentNode,
      ),
      ContentNodeUtils.setState([
        {
          state: {
            styles: { fontSize: '12px', fontWeight: '600' },
          },
        },
      ] as any),
    )

  return (
    <Pill size="sm" {...props}>
      <Text
        color="presets.neutral.80"
        fontSize="12px"
        fontWeight="500"
        mr="8px"
      >
        {contentNode.state?.label}
      </Text>

      <TypeRenderer contentNode={contentNodeWithStyles} />
    </Pill>
  )
}

export const PillWidgetDefinition = createWidget(PillWidget, {
  type: 'Pill',
  slots: [],
  isDataDriven: true,
})
